// extracted by mini-css-extract-plugin
export default {"containerStyles":"ScreenStylesForm_containerStyles__Kf3Cc","containerIcon":"ScreenStylesForm_containerIcon__IjHcN","formButtonSubmit":"ScreenStylesForm_formButtonSubmit__XGIQ6"};